const Fonts = {
	black: "din_black",
	bold: "din_pro_bold",
	regular: "din_pro",
};

export default Fonts;
